<template>
  <div class="news-list-skeleton-wrapper">
    <ul v-if="isLoading" class="news-list-skeleton">
      <li class="news-list-skeleton__item" v-for="i in itemsCount" :key="i">
        <div class="news-list-skeleton__link">
          <div class="news-list-skeleton__img skeleton-block"></div>
          <div class="news-list-skeleton__title skeleton-block"></div>
          <div class="news-list-skeleton__date skeleton-block"></div>
        </div>
      </li>
    </ul>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    itemsCount: {
      type: Number,
      default: 4
    }
  }
};
</script>

<style lang="scss" scoped>
.news-list-skeleton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;

  &__item {
    width: 23%;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;

    &:not(:last-child) {
      margin-right: 16px;
    }

    @media (max-width: 1050px) {
      width: 48%;
      margin-bottom: 16px;

      &:not(:last-child) {
        margin-right: 0;
      }
    }

    @media (max-width: 500px) {
      width: 100%;
    }
  }

  &__img {
    width: 100%;
    height: 120px;
    margin-bottom: 16px;
    border-radius: 4px;
  }

  &__title {
    width: 80%;
    height: 20px;
    margin-bottom: 8px;
    border-radius: 4px;
  }

  &__date {
    width: 60%;
    height: 16px;
    border-radius: 4px;
  }
}

.skeleton-block {
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}
</style>
